/**
 * Visible headers used for output, selection table rendering.
 * @type {string[]}
 */
// Headers for display in table
// export const HEADERS = [
// 	'Request Date',
// 	// 'Create Date',
// 	'Requestor Name',
// 	'Name',
// 	'Action',
// 	'Application',
// 	'Assignee',
// 	'Start Date',
// 	'Tracking Number',
// 	// 'Queue Name',
// ];

// Headers for display in table
export const HEADERS = {
	RequestDate: 'Request Date',
	RequestorName: 'Requestor Name',
	Name: 'Name',
	Action: 'Action',
	Application: 'Application',
	Assignee: 'Assignee',
	StartDate: 'Start Date',
	TrackingNumber: 'Tracking Number',
};

// Headers for search in table
export const HEADERS_FOR_SEARCH = [
	'Request Date',
	// 'Create Date',
	'Start Date',
	'Requestor Name',
	'Name',
	'Tracking Number',
	'Action',
	'Application',
	'Queue Name',
	'Assignee',
	'Pending',
];

// Correlates the column header string name (as key) to the object key returned from API (as key)
export const HeaderDataCorrelation = {
	mainLevel: {
		'Request Date': 'RequestDate',
		Name: 'RequesteeName',
		'Tracking Number': 'TrackingNumber',
		// 'Create Date': 'CreateDate',
		'Requestor Name': 'RequestorName',
		Assignee: 'Assignee_F_Full',
		'Start Date': 'StartDate',
		Pending: 'Pending',
		// RequestType: 'RequestType',
	},
	subLevel: {
		Action: 'RequestType',
		Application: 'Name',
		'Queue Name': 'WorkQueueName',
		ApplicationID: 'ID',
		WorkQueueID: 'WorkQueueID',
		ItemID: 'ItemID',
		Unactionable: 'Unactionable',
		ActionsAvailable: 'Action',
		Username: 'Username',
		// Status: 'Status',
	},
};

export const IDENTIFIER_TYPES = {
	Tracking_Number: 'Tracking Number',
	// Application_ID: 'Application ID',
	// Item_ID: 'Item ID',
};

/**
 * Minimum, maximum permissible number of selections.
 * @type {Object}
 */
export const VALIDATION_THRESHOLD = {
	MIN: 1,
	MAX: 200,
};
